import { FC, useState } from 'react'
import Swal from 'sweetalert2'
import { KTIcon } from '../../../../../_metronic/helpers'
import { setMerchantPaymentPageTimeout } from './api'
import { PAYMENT_PAGE_TIMEOUT_DEFAULT_MINUTES, PAYMENT_PAGE_TIMEOUT_MAX_MINUTES } from './types'

interface Props {
  merchantId: number
  minutes: number | null
}

// Only a positive integer without leading zeros, or an empty field. The gate refuses the keystroke
// instead of cleaning it up afterwards, so the caret does not jump.
const MINUTES_INPUT_RE = /^([1-9]\d*)?$/

const toDraft = (minutes: number | null) => (minutes === null ? '' : String(minutes))

const MerchantPaymentPageTimeout: FC<Props> = ({ merchantId, minutes }) => {
  const [saved, setSaved] = useState<number | null>(minutes)
  const [draft, setDraft] = useState(toDraft(minutes))
  const [saving, setSaving] = useState(false)

  const dirty = draft !== toDraft(saved)

  const onChange = (value: string) => {
    if (!MINUTES_INPUT_RE.test(value)) return
    if (value !== '' && Number(value) > PAYMENT_PAGE_TIMEOUT_MAX_MINUTES) return
    setDraft(value)
  }

  const apply = async () => {
    const next = draft === '' ? null : Number(draft)
    setSaving(true)
    try {
      const res = await setMerchantPaymentPageTimeout(merchantId, next)
      if (!res?.data?.success) {
        throw new Error('save_failed')
      }
      setSaved(next)
      Swal.fire({ toast: true, position: 'top', icon: 'success', title: 'Таймаут страницы обновлён', showConfirmButton: false, timer: 2500 })
    } catch {
      Swal.fire({ toast: true, position: 'top', icon: 'error', title: 'Не удалось сохранить таймаут', showConfirmButton: false, timer: 4000 })
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className='d-flex flex-column gap-1' style={{ maxWidth: 320 }}>
      <div className='d-flex align-items-center gap-2'>
        <input
          type='text'
          inputMode='numeric'
          aria-label='Платёжная страница: таймаут (мин)'
          className='form-control form-control-sm'
          style={{ maxWidth: 100 }}
          placeholder={String(PAYMENT_PAGE_TIMEOUT_DEFAULT_MINUTES)}
          value={draft}
          disabled={saving}
          onChange={(e) => onChange(e.target.value)}
        />
        {dirty && (
          <>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-light-success'
              title='Применить'
              disabled={saving}
              onClick={apply}
            >
              {saving ? (
                <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true' />
              ) : (
                <KTIcon iconName='check' className='fs-2' />
              )}
            </button>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-light-danger'
              title='Сбросить'
              disabled={saving}
              onClick={() => setDraft(toDraft(saved))}
            >
              <KTIcon iconName='cross' className='fs-2' />
            </button>
          </>
        )}
      </div>
      <div className='text-muted fs-8'>
        {`1–${PAYMENT_PAGE_TIMEOUT_MAX_MINUTES} мин; пусто — общий таймаут ${PAYMENT_PAGE_TIMEOUT_DEFAULT_MINUTES} мин`}
      </div>
    </div>
  )
}

export default MerchantPaymentPageTimeout
